/*!
 *
 * Angle - Bootstrap Admin App + AngularJS
 *
 * Version: 3.8
 * Author: @themicon_co
 * Website: http://themicon.co
 * License: https://wrapbootstrap.com/help/licenses
 *
 */

// APP START
// -----------------------------------

(function () {
  'use strict';

  angular
    .module('angle', [
      'app.core',
      'app.routes',
      'app.sidebar',
      'app.navsearch',
      'app.preloader',
      'app.loadingbar',
      'app.translate',
      'app.settings',
      'app.notify',
      'app.utils',
      'app.components',
      'app.login',
      'app.pages'
    ]);
})();
